import { Device } from '@/store/device/types';

import { deviceCouldDownloadApp } from './device';
import redirect from './legacy/redirect';

const sanitizeSlug = (_pathname: string): string => {
	const pathname = typeof _pathname === 'undefined' ? window.location.pathname : _pathname;
	if (pathname.startsWith('/password-reset')) {
		// special-case this one because token muddies it up and is insecure
		return '/password-reset';
	}
	const stripped = (
		pathname.endsWith('/') ? pathname.substr(0, pathname.length - 1) : pathname
	).toLowerCase();
	return stripped || '/';
};

export const mobileSlug = (pathname: string): string => {
	const slug = sanitizeSlug(pathname);
	if (slug === '/profile/stats') return '/profile';
	if (slug === '/profile/change-account-details') return '/settings';
	if (slug === '/profile/manage-subscription') return '/settings';
	// all other URLs match between mobile and web
	return slug;
};

/**
 * Opens an already-built `calm:` deeplink on a phone, with the store as the fallback. Navigating to
 * the scheme is a silent no-op when the app is not installed, so the store is queued first. 100 ms
 * is enough for the OS to intercept the scheme before the fallback fires.
 *
 * Resolves once the fallback has fired, not when the deeplink is requested, so a caller holding a
 * press guard across the attempt keeps it held for the whole window in which a second press would
 * queue a second fallback.
 */
export const openAppDeeplinkOrAppStore = (deeplink: string, device: Device): Promise<void> =>
	new Promise(resolve => {
		const fallback = device.os === 'AndroidOS' ? '/android' : '/ios';
		setTimeout(() => {
			window.location.href = fallback;
			resolve();
		}, 100);
		window.location.assign(deeplink);
	});

export const deeplinkOrAppStore = (pathname: string, device: Device): Promise<void> =>
	openAppDeeplinkOrAppStore(`calm:/${mobileSlug(pathname)}`, device);

export const redirectToWebOrApp = async (pathname: string, device: Device): Promise<void> => {
	if (deviceCouldDownloadApp(device)) {
		await deeplinkOrAppStore(pathname, device);
	} else {
		redirect(pathname);
	}
};
